import { BellOutlined, ExpandAltOutlined } from '@ant-design/icons';
import { Card, Badge } from 'antd';
import React, { useContext, useState } from 'react';
import { Tabs, Tab } from '@mui/material';
import { Link } from 'react-router-dom';
import styled from '@emotion/styled';
import { FilterContextData } from 'contexts/FilterContext';

const StyledTab = ({ label, ...props }: { label: React.ReactNode; [key: string]: any }) => (
    <Tab
        label={label}
        sx={{
            textTransform: 'none',
            fontSize: '12px',
            fontWeight: 500,
            minHeight: '24px',
            minWidth: 'auto',
            padding: '4px 16px',
            borderRadius: '6px',
            color: '#6b7280',
            '&.Mui-selected': {
                color: '#111827',
                backgroundColor: '#ffffff',
                boxShadow: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
            },
        }}
        {...props}
    />
);

export const HomeStyledCardWrapper = styled(Card)`
    height: 100%;
    border-radius: 16px;
    background: hsl(0 0% 100% / 0.7);
    backdrop-filter: blur(8px);
    border: 1px solid hsl(0 0% 90%);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    transition: all 0.3s ease;

    &:hover {
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    }

    .ant-card-body {
        padding: 24px;
    }
`;

const alerts = [
    'Nutrifuel share at Target dipped to 16.8% vs 20.4% year ago',
    'Market leader Haven Mills has declined from 49.6% to 46.9% in share',
    'Consumption of value packs in chocolate going down for own & category',
];

const notifications = ['AOP FY26 Target is 5% value growth vs 2025. Review & create detailed plans for RGM levers'];

export const AlertAndNotificationCard = () => {
    const [activeTab, setActiveTab] = useState<number>(0);
    const { showNotification } = useContext(FilterContextData);

    const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
    };

    return (
        <HomeStyledCardWrapper bordered={false}>
            <div className="relative mb-6">
                <div className="flex items-center gap-4">
                    <div className="flex items-center gap-2">
                        <BellOutlined className="text-xl text-gray-500" />
                        <h3 className="text-lg font-semibold text-gray-800 m-0">Nudges</h3>
                    </div>

                    <Tabs
                        value={activeTab}
                        onChange={handleTabChange}
                        sx={{
                            minHeight: '32px',
                            backgroundColor: '#f3f4f6',
                            borderRadius: '8px',
                            padding: '4px',
                            '& .MuiTabs-indicator': {
                                display: 'none',
                            },
                            '& .MuiTabs-flexContainer': {
                                gap: '4px',
                            },
                        }}
                    >
                        <StyledTab
                            label={
                                <Badge dot={showNotification} offset={[4, 0]}>
                                    <span>Notifications</span>
                                </Badge>
                            }
                        />
                        <StyledTab label="Alerts" />
                    </Tabs>
                </div>

                <Link
                    to="/alert"
                    className="absolute top-0 right-0 text-purpleFont hover:text-gray-900 transition-colors"
                >
                    <p>View All </p>
                </Link>
            </div>

            <div className="relative">
                <div className="flex flex-col gap-3 overflow-y-auto" style={{ maxHeight: '180px', minHeight: '180px' }}>
                    {activeTab === 0 ? (
                        showNotification ? (
                            notifications.map((notification, index) => (
                                <div
                                    key={index}
                                    className="p-3 rounded-lg bg-[#F7F5FF] transition-colors cursor-pointer"
                                >
                                    <p className="text-sm text-gray-800 leading-relaxed m-0">{notification}</p>
                                </div>
                            ))
                        ) : (
                            <div className="p-3 rounded-lg bg-gray-50 text-center">
                                <p className="text-sm text-gray-500 leading-relaxed m-0">
                                    No notifications available for Dave Anderson
                                </p>
                            </div>
                        )
                    ) : (
                        alerts.map((alert, index) => (
                            <div
                                key={index}
                                className="p-3 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors cursor-pointer"
                            >
                                <p className="text-sm text-gray-800 leading-relaxed m-0">{alert}</p>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </HomeStyledCardWrapper>
    );
};
